export default "__VITE_ASSET__D1zk7Rjf__"